// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiClient } from '../services/api-client.js';
import { mfaStepUpPath } from '../utils/mfa-step-up.js';

/**
 * Sprint 63.6.3, gate E12.5 pass 2 — takes a live session that the server holds
 * at the TOTP step-up to the page where a code can be entered.
 *
 * The api-client detects the hold (a 403 `MFA_REQUIRED` on any request except
 * the three a held session is always admitted to, and none while the window is
 * already on the step-up page) and calls the registered function once; this
 * registers a navigation that REPLACES the current history entry, so the back
 * button does not return to the held page and loop. It renders nothing.
 */
export function MfaStepUpRedirector(): null {
  const navigate = useNavigate();
  useEffect(() => {
    apiClient.setOnMfaStepUpRequired((returnTo) => {
      navigate(mfaStepUpPath(returnTo), { replace: true });
    });
    return () => apiClient.setOnMfaStepUpRequired(null);
  }, [navigate]);
  return null;
}
